import React from "react";
import { RotatingLines } from "react-loader-spinner";
import LoadingOverlay from 'react-loading-overlay';

export default function Spinner ({ active, children }) {
    return (
        // <LoadingOverlay
        //     active={active}
        //     spinner
        //     text="Loading..."
        // >
        //     {children}
        // </LoadingOverlay>
        <>
            { active ? 
                <div>
                    {children}
                </div> : null }
        </>
    );
}